import { Platform } from 'react-native';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const { semantic, darkScales } = require('./palette') as {
  semantic: { dark: { background: string; foreground: string; card: string; border: string } };
  darkScales: { neutral: Record<string, string> };
};
const DARK = { ...semantic.dark, neutral: darkScales.neutral };

const tintColorLight = '#FD5001';
const tintColorDark = '#FD5001';

export const Colors = {
  light: {
    text: '#11181C',
    background: '#242120',
    tint: tintColorLight,
    icon: '#687076',
    tabIconDefault: '#687076',
    tabIconSelected: tintColorLight,
    card: '#f9f9f9',
    border: '#2421204a',
  },
  dark: {
    text: DARK.foreground,
    background: DARK.background,
    tint: tintColorDark,
    icon: DARK.neutral['500'],
    tabIconDefault: DARK.neutral['500'],
    tabIconSelected: tintColorDark,
    card: DARK.card,
    border: DARK.border,
  },
};

export const Fonts = Platform.select({
  ios: {
    /** iOS `UIFontDescriptorSystemDesignDefault` */
    sans: 'system-ui',
    /** iOS `UIFontDescriptorSystemDesignSerif` */
    serif: 'ui-serif',
    /** iOS `UIFontDescriptorSystemDesignRounded` */
    rounded: 'ui-rounded',
    /** iOS `UIFontDescriptorSystemDesignMonospaced` */
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    serif: "Georgia, 'Times New Roman', serif",
    rounded: "'SF Pro Rounded', 'Hiragino Maru Gothic ProN', Meiryo, 'MS PGothic', sans-serif",
    mono: "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  },
});
